import "core-js/modules/es.error.cause.js";
/**
 *
 * 判断是否是有效得url地址
 * @export
 * @param {string} url
 * @return {*}  {boolean}
 */
export function isValidURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return reg.test(url);
}
export function validateUrl(rule, value, callback) {
  if (!value) {
    return callback(new Error("请输入链接地址"));
  }
  // 检查是否以http://或https://开头
  if (!value.startsWith("http://") && !value.startsWith("https://")) {
    return callback(new Error("链接必须以 http:// 或 https:// 开头"));
  }
  // 使用正则表达式进行详细的URL格式验证
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  if (!reg.test(value)) {
    return callback(new Error("请输入有效的URL地址格式"));
  }
  callback();
}
/**
 *
 * 判断是否是一个有效的邮箱
 * @export
 * @param {string} eamil
 * @return {*}  {boolean}
 */
export function isValidEmail(eamil) {
  const reg = /^w+([-+.]w+)*@w+([-.]w+)*.w+([-.]w+)*$/;
  return reg.test(eamil);
}
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path);
}
/**
 *
 * 判断字符串是否只含英文字母，数字和中文字符
 * @export
 * @param {string} str
 * @return {*}  {boolean}
 */
export function isOnlyAlphabetOrNumberOrChinese(str) {
  return !/[^a-zA-Z0-9\u4E00-\u9FFF]+/g.test(str);
}
/**
 *
 * 判断字符串是否只含中文
 * @export
 * @param {string} str
 * @return {*}  {boolean}
 */
export function isOnlyChinese(str) {
  return !/[^\u4E00-\u9FFF]+/g.test(str);
}